export default "__VITE_ASSET__CLYvGb_X__"